import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import withDataContext from 'components/withDataContext';
import {
	PERMISSIONS,
	DATA_PERMISSIONS,
	SPEND_CONTROLLER_PERMISSIONS,
	PLANANDTRACK_PERMISSIONS,
	MARKET_ANALYSIS_PERMISSIONS,
	SPEED_TO_MARKET_PERMISSIONS,
} from 'contexts/PermissionsContext';
import { ApAuthenticationContextConsumer } from '@alixpartners/ui-utils';

import SettingsSubnav from './SettingsSubnav';
import UnpublishedControl from './UnpublishedControl';
import { Notifications } from './Notifications';
import { UPLOAD_STATUS } from 'Data/constants';
import { Wrapper, Divider } from './styles';
import {
	ApButtonTab,
	ApButtonIconWrapper,
	ApMenuUser,
	ApMenuItem,
} from '@alixpartners/ui-components';
import get from 'lodash/get';

const getInitials = fullName => {
	return fullName
		.split(' ')
		.map(n => n[0])
		.join('');
};

class NavBase extends React.Component {
	static propTypes = {
		disabled: PropTypes.bool,
	};

	static defaultProps = {
		disabled: false,
	};

	state = {
		currentBookmark: 0,
		bookmarks: [],
	};

	componentWillReceiveProps({ location }) {
		const { state: locationState = {} } = location;

		if (locationState) {
			const hasBookmarks =
				locationState.bookmarks &&
				locationState.bookmarks !== this.state.bookmarks;

			const hasBookmarkIndex =
				locationState.hasOwnProperty('currentIndex') &&
				locationState.currentIndex !== this.state.currentBookmark;

			if (hasBookmarks) {
				this.setState({ bookmarks: locationState.bookmarks });
			}

			if (hasBookmarkIndex) {
				this.setState({ currentBookmark: locationState.currentIndex });
			}
		} else {
			this.setState({ currentBookmark: 0, bookmarks: [] });
		}
	}

	getActiveClassName = path => {
		const { location } = this.props;

		return location.pathname.indexOf(path) === 0 ? 'active' : '';
	};

	render() {
		const { permissions, location, status, config, logout, user } = this.props;
		// const { currentBookmark, bookmarks } = this.state;
		// const showNavBookmarks = bookmarks && bookmarks.length > 0;
		const noData = !status.isDataPublished;
		const forceSettings =
			(status.state === UPLOAD_STATUS.CLASSIFIED &&
				!status.isUnpublishedDataExists) ||
			(config &&
				config.isAlreadyExists &&
				permissions.includes(PERMISSIONS.SettingsClassificationWrite) &&
				status.state === UPLOAD_STATUS.NO_DATA);
		const showDataLink = DATA_PERMISSIONS.some(i => permissions.includes(i));
		const showSpendController = SPEND_CONTROLLER_PERMISSIONS.every(i =>
			permissions.includes(i)
		);
		const showAnalysis = permissions.includes(PERMISSIONS.AnalysisRead);
		const showCategory = permissions.includes(PERMISSIONS.CategoryRead);
		const showPlanAndTrack = PLANANDTRACK_PERMISSIONS.every(i =>
			permissions.includes(i)
		);
		const showMarketAnalysis = MARKET_ANALYSIS_PERMISSIONS.every(i =>
			permissions.includes(i)
		);
		const showBenchmarks = permissions.includes(PERMISSIONS.BenchMarkRead);
		const showSpeedtoMarket = SPEED_TO_MARKET_PERMISSIONS.every(i =>
			permissions.includes(i)
		);

		return (
			<Wrapper>
				{showDataLink && (
					<NavLink
						to="/data"
						title="Data"
						className={this.getActiveClassName('/data')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={location.pathname.includes('/data')}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Data
						</ApButtonTab>
					</NavLink>
				)}

				{showAnalysis && (
					<NavLink
						to="/spend"
						title="Baseline"
						className={this.getActiveClassName('/spend')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={location.pathname.includes('/spend') === 0}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Baseline
						</ApButtonTab>
					</NavLink>
				)}

				{showMarketAnalysis && (
					<NavLink
						to="/market-analysis/vendor-database"
						title="Market Analysis"
						className={this.getActiveClassName(
							'/market-analysis/vendor-database'
						)}
					>
						<ApButtonTab
							theme="dark"
							isSelected={
								location.pathname.includes(
									'/market-analysis/vendor-database'
								) === 0
							}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Market Analysis
						</ApButtonTab>
					</NavLink>
				)}

				{showBenchmarks && (
					<NavLink
						to="/benchmark/benchmarks"
						title="Benchmark"
						className={this.getActiveClassName('/benchmark/benchmarks')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={
								location.pathname.includes('/benchmark/benchmarks') === 0
							}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Benchmark
						</ApButtonTab>
					</NavLink>
				)}

				{showSpeedtoMarket && (
					<NavLink
						to="/speed-to-market/category-widgets"
						title="Speed To Market"
						className={this.getActiveClassName('/speed-to-market')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={location.pathname.includes('/speed-to-market') === 0}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Speed To Market
						</ApButtonTab>
					</NavLink>
				)}

				{showPlanAndTrack && (
					<NavLink
						to="/initiatives/categories"
						title="Plan & Track"
						className={this.getActiveClassName('/initiatives')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={location.pathname.includes('/initiatives') === 0}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Plan & Track
						</ApButtonTab>
					</NavLink>
				)}

				{showCategory && (
					<NavLink
						to="/category-management"
						title="Manage Category"
						className={this.getActiveClassName('/category-management')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={
								location.pathname.includes('/category-management') === 0
							}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Manage Category
						</ApButtonTab>
					</NavLink>
				)}

				{showSpendController && (
					<NavLink
						to="/spend-controller"
						title="Spend Controller"
						className={this.getActiveClassName('/spend-controller')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={location.pathname.indexOf('/spend-controller') === 0}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Spend Controller
						</ApButtonTab>
					</NavLink>
				)}

				<Divider />
				<ApButtonIconWrapper theme="dark">
					<Notifications />
				</ApButtonIconWrapper>
				{permissions.includes(PERMISSIONS.UnpublishedDataRead) && (
					<UnpublishedControl
						isActive={location.pathname.indexOf('/unpublished') === 0}
					/>
				)}
				<SettingsSubnav
					permissions={permissions}
					noData={noData}
					forceSettings={forceSettings}
					config={config}
				/>
				<ApMenuUser
					initials={user ? getInitials(get(user, 'profile.name')) : ''}
				>
					{logout && <ApMenuItem onClick={logout}>Logout</ApMenuItem>}
				</ApMenuUser>
			</Wrapper>
		);
	}
}

export const Nav = withDataContext(NavBase);

export default props => (
	<ApAuthenticationContextConsumer>
		{({ user, logout }) => <Nav user={user} logout={logout} {...props} />}
	</ApAuthenticationContextConsumer>
);
